/**
 * Stable CSS class names for E2E — Customer Comment Approval.
 */
export const CCAPP = {
    page: 'customer-comment-approval-page',
    filterBar: 'customer-comment-approval-page__filter-bar',
    filterSpecialCode: 'customer-comment-approval-page__filter-special-code',
    filterDateRange: 'customer-comment-approval-page__filter-date-range',
    filterStatus: 'customer-comment-approval-page__filter-status',
    filterOperator: 'customer-comment-approval-page__filter-operator',
    filterActions: 'customer-comment-approval-page__filter-actions',

    tableRoot: 'customer-comment-approval-table',
    tableHeaderRow: 'customer-comment-approval-table__header-row',
    tableRow: 'customer-comment-approval-table__row',
    tablePagination: 'customer-comment-approval-table__pagination',

    dialogImageZoom: 'customer-comment-approval-dialog--image-zoom',
    dialogDecline: 'customer-comment-approval-dialog--decline',
    dialogEditSummary: 'customer-comment-approval-dialog--edit-summary',

    input: 'customer-comment-approval-input',
    inputTextfield: 'customer-comment-approval-input--textfield',
    inputSelect: 'customer-comment-approval-input--select',
    inputIconButton: 'customer-comment-approval-input--icon-button',
    inputMenuItem: 'customer-comment-approval-input--menu-item',
    inputButton: 'customer-comment-approval-input--button',

    fieldSpecialCode: 'customer-comment-approval-field--special-code',
    fieldDateRange: 'customer-comment-approval-field--date-range',
    fieldStatus: 'customer-comment-approval-field--status',
    fieldOperator: 'customer-comment-approval-field--operator',
    btnSearch: 'customer-comment-approval-field--search',
    btnExportExcel: 'customer-comment-approval-field--export-excel',

    rowActionsTrigger: 'customer-comment-approval-field--row-actions-trigger',
    rowActionEdit: 'customer-comment-approval-field--row-action-edit',
    rowActionAccept: 'customer-comment-approval-field--row-action-accept',
    rowActionDecline: 'customer-comment-approval-field--row-action-decline',
    fieldAssignToMe: 'customer-comment-approval-field--assign-to-me',
    rowImageZoom: 'customer-comment-approval-field--row-image-zoom',

    fieldDeclineReason: 'customer-comment-approval-field--decline-reason',
    btnDeclineCancel: 'customer-comment-approval-field--decline-cancel',
    btnDeclineConfirm: 'customer-comment-approval-field--decline-confirm',

    fieldEditSummaryText: 'customer-comment-approval-field--edit-summary-text',
    btnEditSummaryCancel: 'customer-comment-approval-field--edit-summary-cancel',
    btnEditSummarySave: 'customer-comment-approval-field--edit-summary-save',
} as const;

export const ccappCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
